import { GET_USER_PERMISSION, REGISTER_ACCESS_GROUPS } from '../constants/urlConstants';
import { ResponseStatus } from '../enums/responseStatus';
import apiRequest from '../util/apiRequest';
import fetchWithRetry from '../util/fetchWithRetry';
import {
  SET_TOKEN_DETAILS,
  SET_SELECTED_ACCESS_GROUP,
  SET_LOGGED_OUT,
  SET_AUTHORIZATION_FAILURE,
  SET_IS_FIRSTVISIT,
  SET_PERMISSION_LEVEL,
  REGISTER_TEAM,
} from './userInfoActionTypes';

/**
 * For the session tokens provided by cognito, save it to redux store
 *
 * @param {*} cognitoAuthSessionData
 * @returns
 */
export const setUserInfoTokensFromSession = cognitoAuthSessionData => dispatch =>
  dispatch({
    type: SET_TOKEN_DETAILS,
    payload: {
      idToken: cognitoAuthSessionData.getIdToken().jwtToken,
      idTokenDecoded: cognitoAuthSessionData.getIdToken().decodePayload(),
      accessToken: cognitoAuthSessionData.getAccessToken().jwtToken,
      accessTokenDecoded: cognitoAuthSessionData.getAccessToken().decodePayload(),
      refreshToken: cognitoAuthSessionData.getRefreshToken().refreshToken,
    },
  });

/**
 * When user belongs to multiple user / access group, based on the dropdown of available
 * access groups, set the selected access group name for this session.
 *
 * @param {*} accessGroupName
 * @returns
 */
export const setSelectedAccessGroup = accessGroupName => ({
  type: SET_SELECTED_ACCESS_GROUP,
  payload: { accessGroupName },
});

/**
 * To mark the end of logged in session
 *
 * @param {*} isLoggedOut
 * @returns
 */
export const setLoggedOut = isLoggedOut => ({
  type: SET_LOGGED_OUT,
  payload: isLoggedOut,
});

/**
 * Mark authorization failure during login
 *
 * @param {*} isFailure
 * @returns
 */
export const setAuthorizationFailure = isFailure => ({
  type: SET_AUTHORIZATION_FAILURE,
  payload: isFailure,
});

/**
 * To mark if the user is visiting the site for first time.
 *
 * @param {*} isFirstVisit
 * @returns
 */
export const setIsFirstVisit = isFirstVisit => ({
  type: SET_IS_FIRSTVISIT,
  payload: isFirstVisit,
});

export const registerAccessGroups = (payload, sessionToken) => dispatch => {
  const url = REGISTER_ACCESS_GROUPS;
  let status = '';
  let data = {};
  return apiRequest(
    url,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
    sessionToken,
  )
    .then(res => {
      if (res?.status >= 400) {
        status = ResponseStatus.ERROR;
      } else {
        status = ResponseStatus.SUCCESS;
      }
      return res.json();
    })
    .then(res => {
      data = res;
    })
    .catch(() => {
      status = ResponseStatus.ERROR;
    })
    .finally(() => {
      dispatch({
        type: REGISTER_TEAM,
        payload: {
          status,
          data,
        },
      });
    });
};

export const getUserPermission = (payload, sessionToken) => dispatch => {
  const url = GET_USER_PERMISSION;
  let status = '';
  let data = {};
  return fetchWithRetry(
    url,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
    sessionToken,
    2,
  )
    .then(res => {
      if (res?.status >= 400) {
        status = ResponseStatus.ERROR;
      } else {
        status = ResponseStatus.SUCCESS;
      }
      return res.json();
    })
    .then(res => {
      data = res;
    })
    .catch(() => {
      status = ResponseStatus.ERROR;
    })
    .finally(() => {
      dispatch({
        type: SET_PERMISSION_LEVEL,
        payload: {
          data,
          status,
        },
      });
    });
};
